import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmployeeService } from '../../../service/employee/employee.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectEmployeeComponent),
  multi: true,
};

@Component({
  selector: 'app-select-employee',
  templateUrl: './select-employee.component.html',
  styleUrls: ['./select-employee.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectEmployeeComponent implements ControlValueAccessor, OnInit {
    @Input() employeeId: number;
    @Input() employeePosition: string;
    @ViewChild('input') textarea;

    public employeeOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public employeeService: EmployeeService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
    }

    ngOnInit() {
        if (this.employeePosition) {
            this.filters.push({key: 'employee_position_id', value: this.employeePosition});
        }

        this.getEmployee(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getEmployee(query?: string, filters?: any[]) {
        this.employeeService.getEmployee(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const employee = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.employeeOptions = [];
                this.employeeOptions.push({id: undefined, name: 'Choose'});
                employee.forEach(element => {
                    if (this.employeeId === element.id) {
                        this.employeeOptions.push({id: element.id, name: element.name, selected: true});
                    } else {
                        this.employeeOptions.push({id: element.id, name: element.name, selected: false});
                    }
                });
            },
            error => {
                this.employeeOptions = [];
                this.employeeOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employees/select-employee/select-employee.component.ts